import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=0f2ab99f&scoped=true&"
import script from "./AppAlert.vue?vue&type=script&lang=js&"
export * from "./AppAlert.vue?vue&type=script&lang=js&"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=0f2ab99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ab99f",
  null
  
)

export default component.exports